<template>
  <el-tooltip  :effect="effect" :content="content" :placement="placement">
     <img src="/static/icon/helpIcon.png" alt="提示"  :style="tipStyle">
  </el-tooltip>
</template>

<script>
  export default {
    props:{
      content:[String],
      effect:{
        type:String,
        default:"dark"
      },
      placement:{
        type:String,
        default:"bottom"
      },
      tipStyle:{
        type:Object,
        default:()=>{
          return {
            width:"14px",
            height:"14px",
            marginLeft:"6px",
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/publicTips/toolTip.vue